
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { NotificationService } from '../../../../../services/shared/notification.service';
import { LicenseService } from '../../../../../services/remote/license.service';
import { QueryResult } from '../../license/types/licenseTypes';
import { LicenseStatus } from '../../../../../types/license';

@Component({
  selector: 'cognos-license-details-general',
  imports: [FormsModule, SelectModule],
  templateUrl: './license-details-general.component.html',
  styleUrl: './license-details-general.component.scss',
})
export class LicenseDetailsGeneralComponent implements OnChanges {
  @Input({ required: true }) license: any;
  @Input({ required: true }) version: string = '';

  public selectedStatus:
    | {
        name: string;
        code: LicenseStatus;
      }
    | undefined;
  public isUpdatingStatus: boolean = false;

  private _isSyncingSelection: boolean = false;

  @Output() statusUpdated = new EventEmitter<LicenseStatus>();

  constructor(
    public licenseService: LicenseService,
    private _notificationService: NotificationService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['license']) {
      this._syncSelectedStatusFromLicense();
    }
  }

  public async onStatusChange(
    statusOption:
      | {
          name: string;
          code: LicenseStatus;
        }
      | null
  ) {
    if (this._isSyncingSelection) return;
    if (!this.license?.id || !statusOption) return;

    const previousStatus: LicenseStatus | undefined = this.license?.status;
    if (statusOption.code === previousStatus) return;

    this.isUpdatingStatus = true;
    const result = await this.licenseService.updateLicenseStatus(
      this.license.id,
      statusOption.code
    );
    this.isUpdatingStatus = false;

    if (result === QueryResult.ok) {
      if (this.license) {
        this.license.status = statusOption.code;
      }
      this._syncSelectedStatusFromLicense(statusOption.code);
      this.statusUpdated.emit(statusOption.code);
      this._notificationService.showSuccessNotification(
        'License status updated successfully.'
      );
    } else {
      this._notificationService.showErrorNotification(
        'Unable to update license status. Please try again.'
      );
      this._syncSelectedStatusFromLicense(previousStatus);
    }
  }

  private _syncSelectedStatusFromLicense(
    statusCode?: LicenseStatus | string | null
  ) {
    this._isSyncingSelection = true;
    const codeToSync = statusCode ?? this.license?.status ?? null;
    this.selectedStatus =
      this.licenseService.statusOptions$.find(
        (status) => status.code === codeToSync
      ) ?? undefined;
    this._isSyncingSelection = false;
  }
}
